// Erzeugt einen stabilen Fingerabdruck aus CSV-Header-Spalten.
// Wird für das Template-Matching in exchangeTemplates verwendet.
// Beispiel: ["Date(UTC)", "Pair", "Type"] → "dateUTC,pair,type"
export function computeFormatSignature(headers) {
  return headers
    .map(h => h.toLowerCase().replace(/[^a-z0-9]/g, ''))
    .filter(h => h.length > 0)
    .sort()
    .join(',');
}
